/* eslint-disable react/no-danger */
import { useRouter } from '@application/utils';

import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { InputField, InputLabel } from '@presentation/components';
import * as Styled from '../styled';

export const Step10: FC = () => {
  const { translate } = useTranslation();
  const { language } = useRouter();
  return (
    <>
      <Styled.BlueInfoBox full>{translate('common.inputs.step9warningText')}</Styled.BlueInfoBox>
      <Styled.OnboardingInputWrapperContainer>
        <Styled.OnboardingInputWrapper>
          <InputLabel required requiredColor="red">
            {translate('common.inputs.breederDogsSelection.label')}
          </InputLabel>
          <InputField name={`translated.${language}.breederDogsSelection`} required />
        </Styled.OnboardingInputWrapper>

        <Styled.OnboardingInputWrapper>
          <InputLabel required requiredColor="red">
            {translate('common.inputs.puppiesTraining.label')}
          </InputLabel>
          <InputField name={`translated.${language}.puppiesTraining`} required />
        </Styled.OnboardingInputWrapper>
      </Styled.OnboardingInputWrapperContainer>
    </>
  );
};
